export default [
    'hw_gb',
    'hw_gb_ttship',
    'hw_usps',
    'zone9_us',
    'zone9_ca',
    'hw_ttship',
    'hw_tiktok',
    'hw_ups',
    'hw_tiktok_gb',
]